<template lang="html">
    <!-- <div class="ps-page--single">
        <bread-crumb :breadcrumb="breadCrumb" />
        <div class="ps-section--custom">
            <div class="container">

                <div class="ps-section__content">
                 <div v-html="v-html">
                 </div>
                </div>
            </div>
        </div>
    </div> -->

<div id="u_body" class="u_body" style="min-height: 100vh; color: #000000; background-color: #fff; font-family: arial,helvetica,sans-serif;">

    <div id="u_row_1" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_1" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">

              <div id="u_content_heading_1" class="u_content_heading" style="overflow-wrap: break-word;padding-top: 40px;">

               <strong> <h3 style="margin: 0px; color: #FB9013; line-height: 140%; text-align: left; word-wrap: break-word; font-weight: normal; font-family: arial,helvetica,sans-serif;">
                  Assured Buy Back
                </h3></strong>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_2" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_2" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px; ">

              <div id="u_content_text_1" class="u_content_text" style="overflow-wrap: break-word;padding-top: 40px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;color:black;"><strong>What is Assured Buy Back?</strong></p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_3" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_3" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_2" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">If a customer wishes to exchange his/her mobile phone purchased from Happi Mobiles, he/she can visit the Happi store along with the following items:</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_10" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">

        <div class="u-row">

          <div id="u_column_10" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_16" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">1. Mobile phone,</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_4" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_4" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_7" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">2. Box and packing,</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_11" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_11" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_17" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">3. Accessories,</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_12" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_12" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_18" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">4. Invoice copy</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_13" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_13" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_19" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">5. Valid ID and address proof</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_5" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_5" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_9" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">The customer with all the above items intact can exchange their phone at Happi store under the following conditions:</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_6" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_6" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_10" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">Note: Customers are not eligible to claim for the first 75 days from the date of the invoice. Post 75 days as per below terms</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_7" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_7" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_11" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">Assured Buy Back Plan for 75 Days</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_8" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_8" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_13" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">If you walk-in for an exchange within 75 days of the date of purchase. Happi Mobiles will buy back your phone for 75% of its value with diagnostics.</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_15" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_15" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_21" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">Assured Buy Back Plan for 76 to 365 Days</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_9" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_9" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_15" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">If the customer wants to exchange his / her phone within 365 days of purchase; Happi Mobiles will buy back your phone for 50% of its value with diagnostics. The checklist for a buyback will be as follows:</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_16" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_16" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_22" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">1.  The physical condition of the handset</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_17" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_17" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_23" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">2.  Invoice copy</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_18" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_18" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_24" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">3.  ID proof</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_19" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_19" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_25" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">4.  Accessories</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_20" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_20" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_26" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">5.  Box and packing</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_21" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_21" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_27" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <p style="font-size: 14px; line-height: 140%;">6.  The handset should be working in mint condition</p>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="u_row_22" class="u_row" style="padding: 0px;">
      <div class="container" style="max-width: 1000px;margin: 0 auto;">
        <div class="u-row">

          <div id="u_column_22" class="u-col u-col-100 u_column">
            <div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;border-radius: 0px;">

              <div id="u_content_text_28" class="u_content_text" style="overflow-wrap: break-word;padding: 10px;">

                <div style="line-height: 140%; text-align: left; word-wrap: break-word;">
                  <h4 style= "line-height: 140%;color:black;"><strong>Note: In case, you are not able to provide accessories/box and packing in the original condition, 10% will be deducted from the buyback value.</strong></h4>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>



</template>

<script>
import BreadCrumb from '~/components/elements/BreadCrumb';

export default {
    components: {
        BreadCrumb,
    },
    transition: 'zoom',
    data: () => {
        return {
            breadCrumb: [
                {
                    text: 'Home',
                    url: '/',
                },
                {
                    text: 'Assured by Back',
                },
            ],
            varhtml: '<p>Loading...</p>',
        };
    },

    // async asyncData(){

    // },
    // async created() {
    //     var axios = require('axios');
    //     var self = this;
    //     var data = JSON.stringify({
    //         url: 'https://dev-happi-static.mobirisesite.com/Assured-Buyback.html'
    //     });

    //     var config = {
    //         method: 'post',
    //         url: 'https://dev-services.happimobiles.com/fetch-page',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         data: data
    //     };

    //     axios(config)
    //         .then(function(response) {
    //             self.varhtml = response.data;
    //         })
    //         .catch(function(error) {
    //             console.log(error);
    //         });

    // }
};
</script>

<style lang="scss" scoped>
// .page-normal-title{
//     color: #FB9013;
//     font-size: 22px;
//     padding-bottom: 20px;
//     // padding-top: 20px;
//     text-align: center;
// }
// .as_bar {
//     top: 51px;
// }
// .content{
//     top: 81px;
// }
    a {
      color: #0000ee;
      text-decoration: underline;
    }

    a:hover {
      color: #0000ee;
      text-decoration: underline;
    }

    .u-row {
      display: flex;
      flex-wrap: nowrap;
      margin-left: 0;
      margin-right: 0;
    }

    .u-row .u-col {
      position: relative;
      width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    .u-row .u-col.u-col-100 {
      flex: 0 0 100%;
      max-width: 100%;
    }

    @media (max-width: 767px) {
      .u-row:not(.no-stack) {
        flex-wrap: wrap;
      }
      .u-row:not(.no-stack) .u-col {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    body,
    html {
      padding: 0;
      margin: 0
    }

    html {
      box-sizing: border-box
    }



    *,
    :after,
    :before {
      box-sizing: inherit
    }

    html {
      font-size: 14px;
      -ms-overflow-style: scrollbar;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
    }

    body {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 1rem;
      line-height: 1.5;
      color: #373a3c;
      background-color: #fff
    }

    p {
      margin: 0
    }

    .error-field {
      -webkit-animation-name: shake;
      animation-name: shake;
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both
    }

    .error-field input,
    .error-field textarea {
      border-color: #a94442!important;
      color: #a94442!important
    }

    .field-error {
      padding: 5px 10px;
      font-size: 14px;
      font-weight: 700;
      position: absolute;
      top: -20px;
      right: 10px
    }

    .field-error:after {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-top-color: #ebcccc;
      border-width: 5px;
      margin-left: -5px
    }

    .spinner {
      margin: 0 auto;
      width: 70px;
      text-align: center
    }

    .spinner>div {
      width: 12px;
      height: 12px;
      background-color: hsla(0, 0%, 100%, .5);
      margin: 0 2px;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both
    }

    .spinner .bounce1 {
      -webkit-animation-delay: -.32s;
      animation-delay: -.32s
    }

    .spinner .bounce2 {
      -webkit-animation-delay: -.16s;
      animation-delay: -.16s
    }

    @-webkit-keyframes sk-bouncedelay {
      0%,
      80%,
      to {
        -webkit-transform: scale(0)
      }
      40% {
        -webkit-transform: scale(1)
      }
    }

    @keyframes sk-bouncedelay {
      0%,
      80%,
      to {
        -webkit-transform: scale(0);
        transform: scale(0)
      }
      40% {
        -webkit-transform: scale(1);
        transform: scale(1)
      }
    }

    @-webkit-keyframes shake {
      0%,
      to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
      }
      10%,
      30%,
      50%,
      70%,
      90% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0)
      }
      20%,
      40%,
      60%,
      80% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0)
      }
    }

    @keyframes shake {
      0%,
      to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
      }
      10%,
      30%,
      50%,
      70%,
      90% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0)
      }
      20%,
      40%,
      60%,
      80% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0)
      }
    }

    @media only screen and (max-width:480px) {
      .container {
        max-width: 100%!important
      }
    }

    .container {
      width: 100%;
      padding-right: 0;
      padding-left: 0;
      margin-right: auto;
      margin-left: auto
    }

    @media (min-width:576px) {
      .container {
        max-width: 540px
      }
    }

    @media (min-width:768px) {
      .container {
        max-width: 720px
      }
    }

    @media (min-width:992px) {
      .container {
        max-width: 960px
      }
    }

    @media (min-width:1200px) {
      .container {
        max-width: 1140px
      }
    }

    a[onclick] {
      cursor: pointer;
    }
  </style>









